import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeft from 'material-ui-icons/ChevronLeft';
import ChevronRight from 'material-ui-icons/ChevronRight';
import ZoomOut from 'material-ui-icons/ZoomOut';
import { NavSamplesActionButton } from './NavSamplesActionButton';

export const NavSamplesActionBar = ({
  loading,
  pageType,
  queryParamsShiftLeft,
  queryParamsShiftRight,
  queryParamsZoomOut
}) => (
  <div>
    <NavSamplesActionButton
      Icon={<ChevronLeft />}
      disabled={loading}
      actionMethod={() => queryParamsShiftLeft()}
    />

    {pageType === 'chart' ? (
      <NavSamplesActionButton
        Icon={<ZoomOut />}
        disabled={loading}
        actionMethod={() => queryParamsZoomOut()}
      />
    ) : null}

    <NavSamplesActionButton
      Icon={<ChevronRight />}
      disabled={loading}
      actionMethod={() => queryParamsShiftRight()}
    />
  </div>
);

NavSamplesActionBar.propTypes = {
  queryParamsShiftLeft: PropTypes.func,
  queryParamsShiftRight: PropTypes.func,
  queryParamsZoomOut: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/nav/NavSamplesActionBar.js